module.exports = __webpack_public_path__ + "static/media/140.72a72c9e.mp3";